module.exports = __webpack_public_path__ + "components/flag/static/square/me-02d1e38f7a22cf58cc9577a5f3d37db6.svg";